let obj = {
  // 0、待完善（已新建）；1、已提交（待审核）；2、待修改；3、正常
  companyStateData: [
    { label: '待完善', value: 0 },
    { label: '已提交', value: 1 },
    { label: '待修改', value: 2 },
    { label: '正常', value: 3 },
  ],
}
export default obj
